// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.image-container {
  position: relative;
  display: inline-block;
  outline: 2px dotted rgb(164, 164, 164) !important;
  border-radius: 3px;
  box-sizing: border-box;
}

img {
  display: block;
  max-width: 100%;
  height: auto;
}

.draggable-point {
  position: absolute;
  width: 1px;
  height: 1px;
  cursor: pointer;
  transform: translate(-50%, -50%);
  caret-color: transparent;
  height: 24px;
  width: 24px;
}
.draggable-point span {
  position: absolute;
  display: block;
  height: 24px;
  width: 24px;
  caret-color: transparent;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
